import React from 'react';
import './hero.css';
import CategoryChips from './CategoryChips';
import SearchAutocomplete from './SearchAutocomplete';
import { useTranslation } from 'react-i18next';

const Hero = ({ categories, selectedCategory, onSelectCategory, onSearch }) => {
  const { t } = useTranslation();
  
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="cashback-banner">
          <span className="banner-icon">⚡</span>
          {t('hero.cashback_banner')}
        </div>
        
        <h1 className="hero-title">
          <span className="hero-title-highlight">{t('hero.title_highlight')}</span>
        </h1>
        
        <p className="hero-sub">
          {t('hero.subtitle')}
        </p>

        <div className="hero-search">
          <SearchAutocomplete
            placeholder={t('hero.search_placeholder')}
            onSearch={onSearch}
            minChars={3}
          />
        </div>

        <CategoryChips 
          categories={categories} 
          selectedCategory={selectedCategory} 
          onSelectCategory={onSelectCategory} 
        />
      </div>
    </section>
  );
};

export default Hero;
